
import { Component, Prop, Vue } from "vue-property-decorator"
import { CaseDetails, Template } from "@/types"
import { namespace } from "vuex-class"
import TemplateSelect from "./TemplateSelect.vue"

const caseStore = namespace("cases")

@Component({
	components: {
		"template-select": TemplateSelect
	}
})
export default class Header extends Vue {
	@Prop({ required: true })
	public currentCase!: CaseDetails

	@caseStore.Getter("getCreatableCategories") public categories!: Template[] | null;

	templateChanged (templateId: string) {
		this.currentCase.templateId = templateId
		this.$emit("templateChanged", templateId)
	}
}
